import React, { createElement } from 'react';
import moduleCss from './index.module.scss';

export interface Iframe_Props {
    nodeId?: string
    style: object; // 组件样式
    url: string; // iframe 链接
    height: number; // iframe 高度
    isScroll: boolean; // iframe 是否可滚动
}

const Iframe: React.FC<Iframe_Props> = (props) => {
    const { nodeId, url, height, style, isScroll } = props;

    return (
        <iframe
            id={nodeId}
            src={url}
            scrolling={isScroll ? 'yes' : 'no'}
            className={moduleCss.iframe}
            style={{ height, ...style }}
        />
    );
};

export default Iframe;
